import { Tooltip } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteInstantControlProps } from './DeleteInstantControl.types';
import * as Styled from './DeleteInstantControl.styles';

export const DeleteInstantControl = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: DeleteInstantControlProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.KONTROLA]?.edit;

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Styled.TrashIcon
          onClick={isPermsDisabled ? undefined : onModalOpen}
          tabIndex={isPermsDisabled ? -1 : 0}
          disabled={isPermsDisabled}
        />
      </Tooltip>
      <ActionModal
        header={formatMessage({ id: AppMessages['control.instant.deleteOwner.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Text>{formatMessage({ id: AppMessages['control.instant.deleteOwner.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
